import { SeasonCard } from '../widgets/SeasonsWidget'
import type { CompetitionGroup } from '../competitions'
import type { StandingRow } from '../../../api/teams'
import styles from './home.module.css'

/** Competitions on the home before the rest belong to the competitions page. */
const MAX_COMPETITIONS = 4

/**
 * Every competition your teams are entered in: the top of its table with your
 * own row, and — for a team you manage — who the league contacts about it.
 *
 * Reached through your roster spots, not your orgs: they are usually run by a
 * league you are not a member of.
 */
export function YourCompetitions({
  groups,
  standings,
  onContactChanged,
}: {
  groups: CompetitionGroup[]
  standings: Record<string, StandingRow[]>
  onContactChanged: () => void
}) {
  if (groups.length === 0) return null
  return (
    <section aria-labelledby="home-competitions" className={styles.section} data-panel="Your competitions">
      <div className={styles.sectionHead}>
        <h2 id="home-competitions" className={styles.sectionTitle}>Your competitions</h2>
      </div>
      <div className={styles.competitions}>
        {groups.slice(0, MAX_COMPETITIONS).map((group) => (
          <SeasonCard
            key={group.competition.season_id}
            group={group}
            standings={standings[group.competition.season_id] ?? []}
            href={`/org/${group.competition.organization_slug}/competitions/${group.competition.slug}`}
            onContactChanged={onContactChanged}
          />
        ))}
      </div>
    </section>
  )
}
